import colors from "shared/styles/colors";
import styled, { css } from "styled-components";
import { Label } from "./Form";

interface IWarningContainerProps {
    disabled?: boolean;
}

// Shared icon font styles
const alertIconFontStyles = css`
    font-family: 'coolicons' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;

// Shared base container styles
const alertContainerBaseStyles = css`
    margin-bottom: 24px;

    .alert-warning {
        margin-bottom: 14px;
    }

    .alert-label {
        font-size: var(--header-3-font-size);
        margin-bottom: 5px;
    }

    .alert-content {
        font-size: 1rem;
    }
`;

export const WarningContainer = styled.div<IWarningContainerProps>`
    ${props => props.disabled ? "" :
        `border-left: solid 3px ${colors.orangePrimary};
        margin-bottom: 24px;
        padding-left: 15px;
        .alert-label, ${Label}  {
            position: relative;
            padding-left: 30px;
            color: ${colors.orangePrimary};
            font-size: var(--header-3-font-size);
            margin-bottom: 5px;
        }

        .alert-label::before {
            position: absolute;
            margin-top: -1px;
            margin-left: -30px;
            color: ${colors.orangePrimary};
            ${alertIconFontStyles}
            font-size: var(--header-2-font-size);
            content: "\\e91f";
        }`}
`;

export const ErrorContainer = styled.div`
    ${alertContainerBaseStyles}
    border-left: solid 3px ${colors.warningPrimary};
    padding-left: 10px;

    .alert-label {
        color: ${colors.warningDark};
    }

    .alert-label::before {
        ${alertIconFontStyles}
        content: "\\e91f";
    }
`;

export const InfoContainer = styled.div`
    ${alertContainerBaseStyles}
    border-left: solid 3px ${colors.bluePrimary};
    padding-left: 10px;

    .alert-label {
        color: ${colors.bluePrimary};
    }

    .alert-label::before {
        ${alertIconFontStyles}
        content: "\\e91f";
    }
`;

export const InfoContainerWithIcon = styled.div`
    ${alertContainerBaseStyles}
    border-left: solid 3px ${colors.bluePrimary};
    padding-left: 12px;

    .alert-label, ${Label} {
        position: relative;
        padding-left: 36px;
        color: ${colors.blueDark};
        font-family: "Gilroy-Medium";
    }

    .alert-label::before {
        ${alertIconFontStyles}
        position: absolute;
        left: 0;
        top: 0;
        width: 24px;
        color: ${colors.bluePrimary};
        font-size: var(--header-2-font-size);
        content: "\\e91c";
    }

    .alert-content {
        padding-left: 36px;
    }
`;